import { auth } from "firebase";
import React from "react";
import Logo from "src/Components/Logo";
import { InputHooksType } from "src/Types/data-types";
import styled from "styled-components";
import SetupSecretKey from "../SetupSecretKey";
import SetupUpline from "../SetupUpline";
import SetupUsername from "../SetupUsername";
import { ProfileSetupTypes } from "./data-types.local";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${(props) => props.theme.extraLightGreyColor};
`;

const Form = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  max-width: ${(props) => props.theme.maxWidth};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem;
  margin-bottom: 1rem;
`;

const BigTitle = styled.h1`
  ${(props) => props.theme.title};
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
`;
const SmallGreyText = styled.p`
  font-size: 0.8rem;
  color: ${(props) => props.theme.darkGreyColor};
`;
interface IProps extends ProfileSetupTypes {
  uplineUsername: InputHooksType;
  name: InputHooksType;
  username: InputHooksType;
  secretKey: InputHooksType;
}
const ProfileSetupPresenter: React.SFC<IProps> = ({
  userInfo,
  refetch,
  uplineUsername,
  name,
  country,
  secretKey,
  username,
}) => {
  if (!userInfo) {
    return (
      <Container>
        <Header>
          <Logo />
        </Header>
        <Form>
          <SmallGreyText>Account setup for</SmallGreyText>
          <BigTitle>{auth().currentUser?.email}</BigTitle>
          <SetupUpline
            uplineUsername={uplineUsername}
            refetch={refetch}
            country={country}
          />
        </Form>
      </Container>
    );
  }

  if (!userInfo.username) {
    return (
      <Container>
        <Header>
          <Logo />
        </Header>
        <Form>
          <SmallGreyText>Account setup for</SmallGreyText>
          <BigTitle>{auth().currentUser?.email}</BigTitle>
          <SetupUsername
            refetch={refetch}
            name={name}
            username={username}
            country={country}
          />
        </Form>
      </Container>
    );
  }
  return (
    <Container>
      <Header>
        <Logo />
      </Header>
      <Form>
        <SmallGreyText>Account setup for</SmallGreyText>
        <BigTitle>{auth().currentUser?.email}</BigTitle>
        <SetupSecretKey
          country={country}
          secretKey={secretKey}
          refetch={refetch}
        />
      </Form>
    </Container>
  );
};

export default ProfileSetupPresenter;
